module.exports = __webpack_public_path__ + "img/38.f10baf30.png";